module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/group_gifting-fd5082d6b06c03c0c428004b01943022.svg";